import TextareaManager from "./Textarea.manager";
import KeyboardManager from "./keyboard.manager";
import { Logging } from "../scripts/Logging";
import config from "../scripts/config";

let TrackCursor = null
let inputArea =  null

export default class DOMManager {
    constructor(){}

    static init(input){
        inputArea =  input
    }
    /**
     * Saving the selection position even with childeren nodes (elements)
     */
    static TrackCursor() {
        if (window.getSelection != null && window.getSelection().getRangeAt && typeof window.getSelection().getRangeAt(0) != 'undefined') {
            var range = window.getSelection().getRangeAt(0);
        }else {
            var range = document.getSelection().getRangeAt(0);
        }

        // if the user not selected text
        if(range.collapsed){
            TrackCursor = {
                "startOffset": range.startOffset ,
                "startContainer": range.startContainer
            }
            DOMManager.setCursor(range.startContainer, range.startOffset) // @Warning colud be deleted
        }else { // if the user selected text
            TrackCursor = {
                "startOffset": range.startOffset ,
                "endOffset": range.endOffset ,
                "startContainer": range.startContainer,
                "endContainer": range.endContainer
            }
        }
    }
    static getCursor(){
        if(TrackCursor == null){
            DOMManager.RestartCursor()
        }
        return TrackCursor
    }

    static setCursor(node, offset){
         TrackCursor = {
                "startOffset":  offset,
                "startContainer": node
            }
    }

    // important for restart the cursor to the begaining of the text area
    static RestartCursor(){
        DOMManager.setCursor(inputArea.childNodes[0], 0)
    }

    static insertAfter(newNode, referenceNode) {
        if(referenceNode.parentNode != null){
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
        }else { // P doesn't see the parentNode
            inputArea.insertBefore(newNode, referenceNode)
        }
    }

    static RestartMessaging(){
        let pargraph = document.createElement("p")
        if(inputArea != null){
            inputArea.innerHTML = ""
            inputArea.appendChild(pargraph)
            DOMManager.RestartCursor()
        }
    }

    static getInputArea(){
        return inputArea;
    }

    static setInputArea(input_id){
        if(input_id != null && input_id != 'undefined'){
            inputArea = document.getElementById(input_id)
        }
    }

    /**Replace collapsed  selection */
    static ReplaceNode(cursor, toAdd){
        for(let j=0; j < inputArea.childNodes[0].childNodes.length ;j++){
            if(typeof cursor.endContainer != 'undefined' && cursor.endContainer.textContent == inputArea.childNodes[0].childNodes[j].textContent){
                let start = cursor.startOffset
                let end = cursor.endOffset
                let parentNode = inputArea.childNodes[0].childNodes[j].parentNode

                let newTextNode = document.createTextNode("")
                newTextNode.textContent = inputArea.childNodes[0].childNodes[j].textContent.slice(0, start)

                inputArea.childNodes[0].childNodes[j].textContent = inputArea.childNodes[0].childNodes[j].textContent.slice(end)
                parentNode.insertBefore(toAdd, inputArea.childNodes[0].childNodes[j])
                parentNode.insertBefore(newTextNode, toAdd)
                break
            }else if (typeof cursor.endContainer == 'undefined' &&
                    cursor.startContainer.textContent == inputArea.childNodes[0].childNodes[j].textContent){
                        let start = cursor.startOffset
                        let end = cursor.endOffset
                        let parentNode = inputArea.childNodes[0].childNodes[j].parentNode

                        let newTextNode = document.createTextNode("")
                        newTextNode.textContent = inputArea.childNodes[0].childNodes[j].textContent.slice(0, start)

                        inputArea.childNodes[0].childNodes[j].textContent = inputArea.childNodes[0].childNodes[j].textContent.slice(end)
                        parentNode.insertBefore(toAdd, inputArea.childNodes[0].childNodes[j])
                        parentNode.insertBefore(newTextNode, toAdd)
            }
        }
        TextareaManager.MoveCursorAfterAdd(0)
    }


    static EditMention(newValue){
        for(let j=0; j < inputArea.childNodes[0].childNodes.length ;j++){ // cols
            if(inputArea.childNodes[0].childNodes[j].textContent == newValue){
                let textNode = document.createTextNode(newValue)
                inputArea.childNodes[0].childNodes[j].replaceWith(textNode)
                TextareaManager.MoveCursorAfterAdd(textNode)
                break
            }
        }
    }

    static replaceNewLine(e, EnterDownCounter){
            for(let j=0; j < inputArea.childNodes[0].childNodes.length;j++){
                if(inputArea.childNodes[0].childNodes[j].nodeName == 'BR'){
                    let line = document.createElement("p")
                    for(let k =j+1;k<inputArea.childNodes[0].childNodes.length;k++){
                        if(inputArea.childNodes[0].childNodes[k].nodeName != 'BR'){
                            line.appendChild(inputArea.childNodes[0].childNodes[k])
                        }else {
                            break
                        }
                    }
                    inputArea.childNodes[0].childNodes[j].outerHTML = ""
                    DOMManager.insertAfter(line,inputArea.childNodes[0])
                    inputArea.innerHTML = inputArea.innerHTML.replace(/\<br\s*[\/]?>/gi, '')
                    TextareaManager.MoveCursorAfterAdd(i+1, EnterDownCounter)
                    break
                }
            }
    }


   static selectElement(element) {
        if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
            var range = document.createRange();
            range.selectNodeContents(element);
            sel.addRange(range);
        } else if (document.selection) {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(element);
            textRange.select();
        }
        return sel
    }

    static clearSelection() {
        if (window.getSelection) {
            window.getSelection().removeAllRanges()
        } else if (document.selection) {
            document.selection.empty()
        }
    }

    static RebuildChatArea(){
        let messageArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        if(typeof messageArea != "undefined" && messageArea != null){
            messageArea.childNodes[0].textContent = ""
            messageArea.focus()
            messageArea.classList.add("empty")
        }
        KeyboardManager.setInputArea(config.DEFAULT_MESSAGE_AREA_ID, false)
        // KeyboardManager.enableChatMode()
        // KeyboardManager.init()
    }

    static clearMessageArea(){
        Logging.Debug("Clearing...")
        if(inputArea == null){
            inputArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        }
        inputArea.childNodes[0].textContent = ""
        inputArea.classList.add("empty")
    }
}
